module.exports = __webpack_public_path__ + "static/img/jt_code.044d4ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/images/jt_code.jpg
// module id = f351
// module chunks = 49